//# sourceMappingURL=label_translations.mjs.map
/// <reference types="./label_translations.d.mts" />
import * as $page from "../../../data_types/data/page.mjs";
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $pair from "../../../gleam_stdlib/gleam/pair.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $label_translations_effects from "../../admin/effects/label_translations.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { Store } from "../../data/store.mjs";

function fetch_current(store, page_index) {
  return $label_translations_effects.fetch(
    page_index,
    store.label_translations_search,
    store.label_translations_language_filter,
    store.label_translations_sort,
  );
}

export function update(store, msg) {
  if (msg instanceof $msg.ApiReturnedLabelTranslations) {
    let page = msg.page;
    let _pipe = new Store(
      store.connections,
      store.organizations,
      store.organizations_tags,
      store.organizations_users,
      store.organizations_invitations,
      store.organizations_enabled_connections,
      store.organizations_ai_config,
      store.organizations_qm_rows,
      store.connected_sockets,
      store.projects,
      store.proposals,
      store.page_index,
      store.proposal_elements,
      store.answers,
      store.translations,
      new $remote.Loaded(page),
      store.label_translations_search,
      store.label_translations_language_filter,
      store.label_translations_sort,
      store.llm_rate_limits,
      store.organizations_activity,
      store.llm_usage,
      store.llm_usage_by_org,
      store.client,
      store.organization,
      store.route,
      store.user,
      store.user_id,
      store.content_library,
      store.ingestion_control_sources,
      store.ingestion_control_sources_visibility,
      store.loading,
      store.users,
      store.roles,
      store.maintenance_mode,
      store.data_sources,
      store.analytics,
      store.metrics_groups,
      store.dashboard_options,
      store.project_files,
      store.weaviate_migrations,
      store.weaviate_collections,
      store.sitemap_urls,
    );
    return $pair.new$(_pipe, $effect.none());
  } else if (msg instanceof $msg.UserRequestedLabelTranslationsPage) {
    let page_index = msg.page_index;
    let _pipe = new Store(
      store.connections,
      store.organizations,
      store.organizations_tags,
      store.organizations_users,
      store.organizations_invitations,
      store.organizations_enabled_connections,
      store.organizations_ai_config,
      store.organizations_qm_rows,
      store.connected_sockets,
      store.projects,
      store.proposals,
      store.page_index,
      store.proposal_elements,
      store.answers,
      store.translations,
      new $remote.Loading(),
      store.label_translations_search,
      store.label_translations_language_filter,
      store.label_translations_sort,
      store.llm_rate_limits,
      store.organizations_activity,
      store.llm_usage,
      store.llm_usage_by_org,
      store.client,
      store.organization,
      store.route,
      store.user,
      store.user_id,
      store.content_library,
      store.ingestion_control_sources,
      store.ingestion_control_sources_visibility,
      store.loading,
      store.users,
      store.roles,
      store.maintenance_mode,
      store.data_sources,
      store.analytics,
      store.metrics_groups,
      store.dashboard_options,
      store.project_files,
      store.weaviate_migrations,
      store.weaviate_collections,
      store.sitemap_urls,
    );
    return $pair.new$(_pipe, fetch_current(store, page_index));
  } else if (msg instanceof $msg.UserRequestedLabelTranslationsSearch) {
    let search = msg.search;
    let _pipe = new Store(
      store.connections,
      store.organizations,
      store.organizations_tags,
      store.organizations_users,
      store.organizations_invitations,
      store.organizations_enabled_connections,
      store.organizations_ai_config,
      store.organizations_qm_rows,
      store.connected_sockets,
      store.projects,
      store.proposals,
      store.page_index,
      store.proposal_elements,
      store.answers,
      store.translations,
      new $remote.Loading(),
      search,
      store.label_translations_language_filter,
      store.label_translations_sort,
      store.llm_rate_limits,
      store.organizations_activity,
      store.llm_usage,
      store.llm_usage_by_org,
      store.client,
      store.organization,
      store.route,
      store.user,
      store.user_id,
      store.content_library,
      store.ingestion_control_sources,
      store.ingestion_control_sources_visibility,
      store.loading,
      store.users,
      store.roles,
      store.maintenance_mode,
      store.data_sources,
      store.analytics,
      store.metrics_groups,
      store.dashboard_options,
      store.project_files,
      store.weaviate_migrations,
      store.weaviate_collections,
      store.sitemap_urls,
    );
    return $pair.new$(
      _pipe,
      fetch_current(
        new Store(
          store.connections,
          store.organizations,
          store.organizations_tags,
          store.organizations_users,
          store.organizations_invitations,
          store.organizations_enabled_connections,
          store.organizations_ai_config,
          store.organizations_qm_rows,
          store.connected_sockets,
          store.projects,
          store.proposals,
          store.page_index,
          store.proposal_elements,
          store.answers,
          store.translations,
          store.label_translations,
          search,
          store.label_translations_language_filter,
          store.label_translations_sort,
          store.llm_rate_limits,
          store.organizations_activity,
          store.llm_usage,
          store.llm_usage_by_org,
          store.client,
          store.organization,
          store.route,
          store.user,
          store.user_id,
          store.content_library,
          store.ingestion_control_sources,
          store.ingestion_control_sources_visibility,
          store.loading,
          store.users,
          store.roles,
          store.maintenance_mode,
          store.data_sources,
          store.analytics,
          store.metrics_groups,
          store.dashboard_options,
          store.project_files,
          store.weaviate_migrations,
          store.weaviate_collections,
          store.sitemap_urls,
        ),
        0,
      ),
    );
  } else if (msg instanceof $msg.UserRequestedLabelTranslationsLanguageFilter) {
    let language = msg.language;
    let _pipe = new Store(
      store.connections,
      store.organizations,
      store.organizations_tags,
      store.organizations_users,
      store.organizations_invitations,
      store.organizations_enabled_connections,
      store.organizations_ai_config,
      store.organizations_qm_rows,
      store.connected_sockets,
      store.projects,
      store.proposals,
      store.page_index,
      store.proposal_elements,
      store.answers,
      store.translations,
      new $remote.Loading(),
      store.label_translations_search,
      language,
      store.label_translations_sort,
      store.llm_rate_limits,
      store.organizations_activity,
      store.llm_usage,
      store.llm_usage_by_org,
      store.client,
      store.organization,
      store.route,
      store.user,
      store.user_id,
      store.content_library,
      store.ingestion_control_sources,
      store.ingestion_control_sources_visibility,
      store.loading,
      store.users,
      store.roles,
      store.maintenance_mode,
      store.data_sources,
      store.analytics,
      store.metrics_groups,
      store.dashboard_options,
      store.project_files,
      store.weaviate_migrations,
      store.weaviate_collections,
      store.sitemap_urls,
    );
    return $pair.new$(
      _pipe,
      fetch_current(
        new Store(
          store.connections,
          store.organizations,
          store.organizations_tags,
          store.organizations_users,
          store.organizations_invitations,
          store.organizations_enabled_connections,
          store.organizations_ai_config,
          store.organizations_qm_rows,
          store.connected_sockets,
          store.projects,
          store.proposals,
          store.page_index,
          store.proposal_elements,
          store.answers,
          store.translations,
          store.label_translations,
          store.label_translations_search,
          language,
          store.label_translations_sort,
          store.llm_rate_limits,
          store.organizations_activity,
          store.llm_usage,
          store.llm_usage_by_org,
          store.client,
          store.organization,
          store.route,
          store.user,
          store.user_id,
          store.content_library,
          store.ingestion_control_sources,
          store.ingestion_control_sources_visibility,
          store.loading,
          store.users,
          store.roles,
          store.maintenance_mode,
          store.data_sources,
          store.analytics,
          store.metrics_groups,
          store.dashboard_options,
          store.project_files,
          store.weaviate_migrations,
          store.weaviate_collections,
          store.sitemap_urls,
        ),
        0,
      ),
    );
  } else if (msg instanceof $msg.UserRequestedLabelTranslationsSort) {
    let sort = msg.sort;
    let _pipe = new Store(
      store.connections,
      store.organizations,
      store.organizations_tags,
      store.organizations_users,
      store.organizations_invitations,
      store.organizations_enabled_connections,
      store.organizations_ai_config,
      store.organizations_qm_rows,
      store.connected_sockets,
      store.projects,
      store.proposals,
      store.page_index,
      store.proposal_elements,
      store.answers,
      store.translations,
      new $remote.Loading(),
      store.label_translations_search,
      store.label_translations_language_filter,
      sort,
      store.llm_rate_limits,
      store.organizations_activity,
      store.llm_usage,
      store.llm_usage_by_org,
      store.client,
      store.organization,
      store.route,
      store.user,
      store.user_id,
      store.content_library,
      store.ingestion_control_sources,
      store.ingestion_control_sources_visibility,
      store.loading,
      store.users,
      store.roles,
      store.maintenance_mode,
      store.data_sources,
      store.analytics,
      store.metrics_groups,
      store.dashboard_options,
      store.project_files,
      store.weaviate_migrations,
      store.weaviate_collections,
      store.sitemap_urls,
    );
    return $pair.new$(
      _pipe,
      fetch_current(
        new Store(
          store.connections,
          store.organizations,
          store.organizations_tags,
          store.organizations_users,
          store.organizations_invitations,
          store.organizations_enabled_connections,
          store.organizations_ai_config,
          store.organizations_qm_rows,
          store.connected_sockets,
          store.projects,
          store.proposals,
          store.page_index,
          store.proposal_elements,
          store.answers,
          store.translations,
          store.label_translations,
          store.label_translations_search,
          store.label_translations_language_filter,
          sort,
          store.llm_rate_limits,
          store.organizations_activity,
          store.llm_usage,
          store.llm_usage_by_org,
          store.client,
          store.organization,
          store.route,
          store.user,
          store.user_id,
          store.content_library,
          store.ingestion_control_sources,
          store.ingestion_control_sources_visibility,
          store.loading,
          store.users,
          store.roles,
          store.maintenance_mode,
          store.data_sources,
          store.analytics,
          store.metrics_groups,
          store.dashboard_options,
          store.project_files,
          store.weaviate_migrations,
          store.weaviate_collections,
          store.sitemap_urls,
        ),
        0,
      ),
    );
  } else if (msg instanceof $msg.UserRequestedDeleteTranslation) {
    let id = msg.id;
    let version = msg.version;
    let _pipe = store;
    return $pair.new$(_pipe, $label_translations_effects.delete$(id, version));
  } else if (msg instanceof $msg.ApiDeletedTranslation) {
    let id = msg.id;
    let version = msg.version;
    let _block;
    let $ = store.label_translations;
    if ($ instanceof $remote.Loaded) {
      let pagination = $[0];
      _block = new $remote.Loaded(
        new $page.Pagination(
          pagination.total,
          pagination.page_size,
          pagination.page_index,
          pagination.page_count,
          (() => {
            let _pipe = pagination.elements;
            return $list.filter(
              _pipe,
              (t) => { return !((t.id === id) && (t.version === version)); },
            );
          })(),
        ),
      );
    } else {
      _block = $;
    }
    let label_translations = _block;
    let _pipe = new Store(
      store.connections,
      store.organizations,
      store.organizations_tags,
      store.organizations_users,
      store.organizations_invitations,
      store.organizations_enabled_connections,
      store.organizations_ai_config,
      store.organizations_qm_rows,
      store.connected_sockets,
      store.projects,
      store.proposals,
      store.page_index,
      store.proposal_elements,
      store.answers,
      store.translations,
      label_translations,
      store.label_translations_search,
      store.label_translations_language_filter,
      store.label_translations_sort,
      store.llm_rate_limits,
      store.organizations_activity,
      store.llm_usage,
      store.llm_usage_by_org,
      store.client,
      store.organization,
      store.route,
      store.user,
      store.user_id,
      store.content_library,
      store.ingestion_control_sources,
      store.ingestion_control_sources_visibility,
      store.loading,
      store.users,
      store.roles,
      store.maintenance_mode,
      store.data_sources,
      store.analytics,
      store.metrics_groups,
      store.dashboard_options,
      store.project_files,
      store.weaviate_migrations,
      store.weaviate_collections,
      store.sitemap_urls,
    );
    return $pair.new$(_pipe, $effect.none());
  } else if (msg instanceof $msg.UserRequestedDeleteLabelTranslations) {
    let target_id = msg.target_id;
    let _pipe = store;
    return $pair.new$(
      _pipe,
      $label_translations_effects.delete_label(target_id),
    );
  } else if (msg instanceof $msg.ApiDeletedLabelTranslations) {
    let target_id = msg.target_id;
    let _block;
    let $ = store.label_translations;
    if ($ instanceof $remote.Loaded) {
      let pagination = $[0];
      _block = new $remote.Loaded(
        new $page.Pagination(
          pagination.total,
          pagination.page_size,
          pagination.page_index,
          pagination.page_count,
          (() => {
            let _pipe = pagination.elements;
            return $list.filter(
              _pipe,
              (t) => { return t.target_id !== target_id; },
            );
          })(),
        ),
      );
    } else {
      _block = $;
    }
    let label_translations = _block;
    let _pipe = new Store(
      store.connections,
      store.organizations,
      store.organizations_tags,
      store.organizations_users,
      store.organizations_invitations,
      store.organizations_enabled_connections,
      store.organizations_ai_config,
      store.organizations_qm_rows,
      store.connected_sockets,
      store.projects,
      store.proposals,
      store.page_index,
      store.proposal_elements,
      store.answers,
      store.translations,
      label_translations,
      store.label_translations_search,
      store.label_translations_language_filter,
      store.label_translations_sort,
      store.llm_rate_limits,
      store.organizations_activity,
      store.llm_usage,
      store.llm_usage_by_org,
      store.client,
      store.organization,
      store.route,
      store.user,
      store.user_id,
      store.content_library,
      store.ingestion_control_sources,
      store.ingestion_control_sources_visibility,
      store.loading,
      store.users,
      store.roles,
      store.maintenance_mode,
      store.data_sources,
      store.analytics,
      store.metrics_groups,
      store.dashboard_options,
      store.project_files,
      store.weaviate_migrations,
      store.weaviate_collections,
      store.sitemap_urls,
    );
    return $pair.new$(_pipe, $effect.none());
  } else if (msg instanceof $msg.UserRequestedDeleteAllLabelTranslations) {
    let _pipe = new Store(
      store.connections,
      store.organizations,
      store.organizations_tags,
      store.organizations_users,
      store.organizations_invitations,
      store.organizations_enabled_connections,
      store.organizations_ai_config,
      store.organizations_qm_rows,
      store.connected_sockets,
      store.projects,
      store.proposals,
      store.page_index,
      store.proposal_elements,
      store.answers,
      store.translations,
      new $remote.Loading(),
      store.label_translations_search,
      store.label_translations_language_filter,
      store.label_translations_sort,
      store.llm_rate_limits,
      store.organizations_activity,
      store.llm_usage,
      store.llm_usage_by_org,
      store.client,
      store.organization,
      store.route,
      store.user,
      store.user_id,
      store.content_library,
      store.ingestion_control_sources,
      store.ingestion_control_sources_visibility,
      store.loading,
      store.users,
      store.roles,
      store.maintenance_mode,
      store.data_sources,
      store.analytics,
      store.metrics_groups,
      store.dashboard_options,
      store.project_files,
      store.weaviate_migrations,
      store.weaviate_collections,
      store.sitemap_urls,
    );
    return $pair.new$(_pipe, $label_translations_effects.delete_all());
  } else {
    let _pipe = new Store(
      store.connections,
      store.organizations,
      store.organizations_tags,
      store.organizations_users,
      store.organizations_invitations,
      store.organizations_enabled_connections,
      store.organizations_ai_config,
      store.organizations_qm_rows,
      store.connected_sockets,
      store.projects,
      store.proposals,
      store.page_index,
      store.proposal_elements,
      store.answers,
      store.translations,
      new $remote.Loaded($page.empty_page),
      store.label_translations_search,
      store.label_translations_language_filter,
      store.label_translations_sort,
      store.llm_rate_limits,
      store.organizations_activity,
      store.llm_usage,
      store.llm_usage_by_org,
      store.client,
      store.organization,
      store.route,
      store.user,
      store.user_id,
      store.content_library,
      store.ingestion_control_sources,
      store.ingestion_control_sources_visibility,
      store.loading,
      store.users,
      store.roles,
      store.maintenance_mode,
      store.data_sources,
      store.analytics,
      store.metrics_groups,
      store.dashboard_options,
      store.project_files,
      store.weaviate_migrations,
      store.weaviate_collections,
      store.sitemap_urls,
    );
    return $pair.new$(_pipe, $effect.none());
  }
}
